import React, { Fragment, useCallback, useEffect, useRef, useState } from 'react';
import { Form } from 'react-final-form';

import Alert from '../../ui/Alert';
import { useToken, WalletService } from '../../../services';
import { formatMoney } from '../../../util';

import Card from '../../ui/Card';
import Input from '../../ui/Input';

import './styles.css';
import StateView from '../../ui/StateView';

function Notification() {
  const { getToken } = useToken();
  const intervalRef = useRef(null);
  const refSetState = useRef(true);
  const [states, setStates] = useState({
    msg: '',
    error: false,
    loading: false,
    label: 'Salvar',
    enableMsg: false,
  });

  const [retrieve, setRetrieve] = useState({
    data: {},
    error: false,
    loading: false,
  });

  const handleValidation = useCallback(
    async (formData, submit = false) => {
      if ((!!formData['amount'] && !!formData['email']) || submit) {
        const errors = {
          email: '',
          amount: '',
        }

        const dataAmount = Number(String(formData['amount']).replace(/\D/g, ''));
        if (dataAmount <= 0 || isNaN(dataAmount)) {
          errors['amount'] = "Valor inválido."
        }

        const dataEmail = String(formData['email']);
        if (dataEmail.length < 5 || !dataEmail.includes('@')) {
          errors['email'] = "E-mail inválido."
        }

        if (Object.values(errors).some(i => i !== '')) {
          return errors;
        }
      }
    },
    [],
  );

  const requestData = useCallback(async () => {
    let data = {};
    let error = false;

      setRetrieve(stt => ({
        ...stt, 
        error,
        loading: true,
      }));

      try {
        const token = await getToken();
        const result = await WalletService.getNotification({ token });

        if (result.error) {
          throw new Error(result.msgError);
        }
        
        data = Object.fromEntries(
          Object.entries(result.data).map(
            i => [i[0], i[1] === null ? '' : i[1] ]
          )
        );
      } catch (err) {
        error = true;
      } finally {
        if (refSetState.current) {
          setRetrieve({ 
            data, 
            error,
            loading: false,
          });
        }
      }
  }, []);

  const handleSubmitForm = useCallback(
    async (formData, form) => {
      const validations = await handleValidation(formData, true);
      if (validations) return validations;

      let msg = '';
      let error = false;

      setStates(stt => ({
        ...stt, 
        loading: true, 
        enableMsg: false, 
        label: 'Carregando...'
      }));

      try {
        const token = await getToken();

        const data = {
          token,
          email: formData['email'],
          amount: Number(String(formData['amount']).replace(/\D/g, '')),
        }

        const result = await WalletService.putNotification(data);

        if (result.error) {
          throw new Error(result.msgError);
        }

        msg = 'Notificação atualizada com sucesso.';
      } catch (err) {
        error = true;
        if (err instanceof Error) {
          msg = err.message.slice(0, 80);
        }
      } finally {
        if (refSetState.current) {
          setStates({ 
            msg,
            error, 
            loading: false, 
            label: 'Salvar',
            enableMsg: true,
          });

          if (!error) {
            requestData();
            setTimeout(form.reset);
            clearInterval(intervalRef.current);
            intervalRef.current = setInterval(() => {
              setStates(stt => ({...stt, enableMsg: false }));
            }, 4000);
          }
        }
      }
    },
    [handleValidation],
  );

  useEffect(() => {
    refSetState.current = true;

    requestData();

    return () => {
      refSetState.current = false;
      clearInterval(intervalRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  return (
    <Card 
      title="Notificação" 
      disabled={states.loading}
      description="Configuração para recebimento de alerta quando o saldo estiver abaixo do mínimo" 
      >
      {states.enableMsg && (
        <Alert
          msg={states.msg} 
          error={states.error}
          onClose={() => {
            setStates(stt => ({...stt, enableMsg: false }));
          }}
        />
      )}
      <div className="notify__data">
        <h5>Dados salvos:</h5>
        <StateView
          error={retrieve.error}
          loading={retrieve.loading}
          empty={Object.keys(retrieve.data).length === 0}
          viewLoading={
            <Fragment>
              <p className="loading"> </p>
              <p className="loading"> </p>
            </Fragment>
          }
          viewError={
            <p className="error">Erro ao buscar dados.</p>
          }
          viewEmpty={
            <p>Não há dados cadastrados ainda.</p>
          }
        >
          <p><strong>E-Mail: </strong>{retrieve.data['email']}</p>
          <p><strong>Valor: </strong>{formatMoney(retrieve.data['amount'] || 0)}</p>
        </StateView>
      </div>
      <Form
        onSubmit={handleSubmitForm}
        validate={handleValidation}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit} className="wa__form">
            <Input
              type="text"
              name="email"
              label="E-Mail:"
              placeholder="E-Mail que irá receber a notificação"
            />
            <Input
              type="text"
              name="amount"
              label="Valor:"
              placeholder="Valor mínimo para notificar"
              onMask={(val) => {
                const number = String(val).replace(/\D/g, '');
                return number === '' ? '' : `R$ ${number}`;
              }}
            />
            <button 
              type="submit" 
              className="z-button"
              disabled={states.loading}>
              {states.label}
            </button>
          </form>
        )}
      />
    </Card>
  );
}

export default Notification;


// WEBPACK FOOTER //
// ./src/components/Pages/Wallet/components/functional/Notification/index.js